<template>
  <RF-Aba :cpntButtons='buttons'></RF-Aba>
</template>

<script>
  export default {
    components: {
      'RF-Aba': () => import('@/components/rf-geral/aba/RF-Aba.vue')
    },
    data: function () {
      return {
        buttons: []
      }
    },
    mounted: function () {
      // RESETA O MENU EXISTENTE
      this.buttons = []

      // ADICIONA A ABA SESSÃO DO USUARIO
      this.buttons.push({ nome: 'Atualizações', router: this.$router.resolve({ name: 'subase_painel_atualizar', params: { cts: this.$store.state.token.cts } }).href, aRouterSelect: [ 'subase_painel_atualizar' ] })
    }
  }
</script>
